import correctMerge from 'lodash.merge';
import jwtDecode from 'jwt-decode';

let decodedToken;

function createError(configPath, configPathValue, validValues) {
    throw new Error(`Specified ${configPath} '${configPathValue}' is not valid. Valid values are: ${validValues.join(', ')}`);
}

function verifyValues(loaderConfig) {
    const validEnvironments = ['qa', 'uat', 'prod'];
    const validRegions = ['apac', 'emea', 'us'];
    const validTypes = ['config-api', 'mwc-cdn', 'url', 'none'];
    const mwcApplicationHelper = 'mwc-application-helper';

    if (validEnvironments.indexOf(loaderConfig.component.source.environment) === -1) {
        createError('loaderConfig.component.source.environment', loaderConfig.component.source.environment, validEnvironments);
    }

    if ([...validEnvironments, 'stg'].indexOf(loaderConfig.configuration.environment) === -1) {
        createError('loaderConfig.configuration.environment', loaderConfig.configuration.environment, [...validEnvironments, 'stg']);
    }

    if (validEnvironments.indexOf(loaderConfig.configuration.source.environment) === -1) {
        createError('loaderConfig.configuration.source.environment', loaderConfig.configuration.source.environment, validEnvironments);
    }

    if (validEnvironments.indexOf(loaderConfig.runtime.environment) === -1) {
        createError('loaderConfig.runtime.environment', loaderConfig.runtime.environment, validEnvironments);
    }

    if (validRegions.indexOf(loaderConfig.runtime.region) === -1) {
        createError('loaderConfig.runtime.region', loaderConfig.runtime.region, validRegions);
    }

    if (loaderConfig.mwc && loaderConfig.mwc[mwcApplicationHelper] && loaderConfig.mwc[mwcApplicationHelper].environment) {
        if (validEnvironments.indexOf(loaderConfig.mwc[mwcApplicationHelper].environment) === -1) {
            createError('loaderConfig.mwc.mwc-application-helper.environment', loaderConfig.mwc[mwcApplicationHelper].environment, validEnvironments);
        }
    }

    if (validTypes.indexOf(loaderConfig.configuration.source.type) === -1) {
        createError('loaderConfig.configuration.source.type', loaderConfig.configuration.source.type, validTypes);
    }

    if (validRegions.indexOf(loaderConfig.configuration.source.region) === -1) {
        createError('loaderConfig.configuration.source.region', loaderConfig.configuration.source.region, validRegions);
    }

    if (loaderConfig.userIdentity && loaderConfig.userIdentity.userId && loaderConfig.userIdentity.getUserIdFromToken) {
        throw new Error('If a userId is provided, getUserIdFromToken must be false.');
    }

    if (loaderConfig.userIdentity && loaderConfig.userIdentity.getUserIdFromToken && !loaderConfig.apiTokens.apiGatewayToken) {
        throw new Error('If getUserIdFromToken is true, "apiGatewayToken" must be provided.');
    }

    if (loaderConfig.apiTokens.apiGatewayToken) {
        try {
            decodedToken = jwtDecode(loaderConfig.apiTokens.apiGatewayToken.substring(7));
            if (!decodedToken) {
                throw new Error('The provided apiGatewayToken is invalid.');
            }
        } catch (error) {
            throw new Error('The provided apiGatewayToken is invalid.');
        }
    }

    if (!loaderConfig.configuration.namespace && loaderConfig.configuration.environment === 'prod') {
        console.warn('Running in production mode without a namespace is not recommended and will throw an error in future updates.');
    }
}

/**
 * Set default values for the loader configuration
 * @param  {*} loaderConfig - Contains all configuration options for the loader
 */
function setDefaultValues(loaderConfig) {
    const skeletonConfig = {
        asterix: {},
        apiTokens: {},
        component: {},
        configuration: {},
        css: {},
        instrumentation: {},
        morningstarUsageTracking: {},
        runtime: {},
    };
    const defaultLoaderConfig = {
        asterix: {
            angular: {},
        },
        api: {},
        apiTokens: {},
        component: {
            source: {
                environment: 'prod',
            },
        },
        configuration: {
            environment: 'prod',
            source: {
                type: 'config-api',
                version: 1,
                environment: 'prod',
                region: 'us',
            },
        },
        css: {
            includeComponentCss: true,
            mds: {
                icons: false,
                style: false,
            },
        },
        instrumentation: {
            providers: [],
        },
        lazy: false,
        morningstarUsageTracking: {
            enabled: true,
            applicationId: '465817912',
        },
        runtime: {
            environment: 'prod',
            region: 'us',
        },
    };

    // This overrides any top-level null values in the loaderConfig object
    let mergedConfig = correctMerge({}, loaderConfig, skeletonConfig);
    // Get the merge of defaultLoaderConfig with overrides from loaderConfig
    mergedConfig = correctMerge({}, defaultLoaderConfig, mergedConfig);
    // Override loaderConfig with the mergedConfig object (since we need to update the loaderConfig object)
    correctMerge(loaderConfig, mergedConfig);

    if (loaderConfig.apiTokens.apiGatewayToken && (loaderConfig.apiTokens.apiGatewayToken.indexOf('Bearer ') !== 0)) {
        loaderConfig.apiTokens.apiGatewayToken = `Bearer ${loaderConfig.apiTokens.apiGatewayToken}`;
    }

    // Ensure morningstarUsageTracking is enabled by default (must be false, not just falsy, to disable it)
    if (loaderConfig.morningstarUsageTracking.enabled === null) {
        loaderConfig.morningstarUsageTracking.enabled = true;
    }
    verifyValues(loaderConfig);
    if (loaderConfig.userIdentity && loaderConfig.userIdentity.getUserIdFromToken) {
        loaderConfig.userIdentity.userId = decodedToken.sub;
    }
}

export default setDefaultValues;



// WEBPACK FOOTER //
// ../loader-base/src/helpers/set-default-values.js